import { render, staticRenderFns } from "./ImportPluggy.vue?vue&type=template&id=4271d034&"
import script from "./ImportPluggy.vue?vue&type=script&lang=js&"
export * from "./ImportPluggy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports